import Immutable from 'seamless-immutable';
import _ from 'lodash';

const SET_ERRORS = 'SET_ERRORS';
const CLEAR_ERRORS = 'CLEAR_ERRORS';
const CLEAR_ERROR_BY_FIELD = 'CLEAR_ERROR_BY_FIELD';
const INIT_STATE = 'INIT_STATE';

const reducerName = `formErrors`;
const createReducerDotPathName = combineName => `${combineName}.${reducerName}`;

const createActionName = (combineName, name) =>
  `app/${createReducerDotPathName(combineName)}/${name}`;
export const getState = (state, combineName) =>
  _.get(state, createReducerDotPathName(combineName));

const createFormErrorsReducer = combineName => {
  function stateDefault() {
    return {
      errors: {}
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(combineName, SET_ERRORS):
        return state.merge({
          errors: _.groupBy(action.payload, 'field')
        });
      case createActionName(combineName, CLEAR_ERRORS):
        return state.merge({
          errors: {}
        });
      case createActionName(combineName, CLEAR_ERROR_BY_FIELD): {
        const newErrors = { ...state.errors };
        delete newErrors[action.payload];
        return state.merge({
          errors: newErrors
        });
      }
      case createActionName(combineName, INIT_STATE):
        return Immutable(stateDefault());
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName) {
  const reduceObject = {};
  reduceObject[reducerName] = createFormErrorsReducer(combineName);
  return reduceObject;
}

// ACTION CREATOR
export const setErrors = (combineName, payload) => ({
  type: createActionName(combineName, SET_ERRORS),
  payload
});
export const clearErrors = combineName => ({
  type: createActionName(combineName, CLEAR_ERRORS)
});
export const clearErrorByField = (combineName, payload) => ({
  type: createActionName(combineName, CLEAR_ERROR_BY_FIELD),
  payload
});
export const initState = combineName => ({
  type: createActionName(combineName, INIT_STATE)
});

// SELECTORS
export const hasFieldError = (state, combineName, fieldName) =>
  _.get(getState(state, combineName), `errors.${fieldName}`) !== undefined;

export const selectFirstErrorByFiled = (state, combineName, fieldName) => {
  const errorField = _.get(getState(state, combineName), `errors.${fieldName}`);
  if (errorField) {
    return errorField[0];
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/mt-react-common/common/reducers/_formErrors/reducer.js